import React from 'react';
import { Form, Icon, Input, Button, Alert } from 'antd';
import { useHistory } from 'react-router-dom';

const FormItem = Form.Item;

const AdminLoginForm = ({
  form,
  loginRequest,
  loginHasError,
  adminLogin,
  errorMessage
}) => {
  const history = useHistory();
  const { getFieldDecorator } = form;

  const onSubmit = e => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (!err) {
        await adminLogin({
          email: values.email,
          password: values.password,
          clientEmail: values.clientEmail
        });
        // Redirect to dashboard after successful login
        history.push('/dashboard');
      }
    });
  };

  return (
    <>
      {loginHasError && errorMessage !== '' && <Alert message={errorMessage} type="error" />}
      <Form onSubmit={onSubmit} className="login-form">
        <h3 style={{ marginBottom: 24 }}>Admin Login - Log in as Another User</h3>
        <FormItem>
          {getFieldDecorator('email', {
            validateTrigger: 'onBlur',
            rules: [
              { type: 'email', message: 'Please input a valid email.' },
              { required: true, message: 'Please input your admin email.' }
            ]
          })(
            <Input
              prefix={<Icon type="mail" style={{ fontSize: 13 }} />}
              placeholder="Admin Email"
              disabled={loginRequest}
              spellCheck={false}
            />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your admin password.' }]
          })(
            <Input
              prefix={<Icon type="lock" style={{ fontSize: 13 }} />}
              type="password"
              placeholder="Admin Password"
              disabled={loginRequest}
            />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('clientEmail', {
            validateTrigger: 'onBlur',
            rules: [
              { type: 'email', message: 'Please input a valid email.' },
              { required: true, message: 'Please input the email of the user you want to log in as.' }
            ]
          })(
            <Input
              prefix={<Icon type="user" style={{ fontSize: 13 }} />}
              placeholder="Client Email (User to log in as)"
              disabled={loginRequest}
              spellCheck={false}
            />
          )}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" loading={loginRequest} className="login-form-btn">
            {loginRequest ? 'Logging in' : 'Log in as User'}
          </Button>
        </FormItem>
      </Form>
    </>
  );
};

export default Form.create()(AdminLoginForm);
